<template>
  <footer class="layout-footer footer bg-footer-theme">
    <div class="container">
      <span class="text-muted">© 2025 Pika Aero. All Rights Reserved.</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques au footer */
</style>
